<h2 mat-dialog-title>{{ 'workplace.delete.title' | transloco }}</h2>
<mat-dialog-content>
	<p>{{ 'workplace.delete.confirmation' | transloco }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<lvr-button
		style="padding-right: 1rem"
		variant="secondary"
		[label]="'workplace.delete.cancel' | transloco"
		[type]="'button'"
		icon="disabled_by_default"
		mat-dialog-close
	>
	</lvr-button>
	<lvr-button
		variant="primary"
		[label]="'workplace.delete.delete' | transloco"
		[type]="'button'"
		[loading]="loading()"
		[loadingLabel]="'workplace.delete.deleting' | transloco"
		(clicked)="deleteWorkplace()"
		icon="delete"
	>
	</lvr-button>
</mat-dialog-actions>
